// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"style__pageWrapper__Tl4hc","body":"style__body__fbQ-k","footer":"style__footer__7UJuK"};